import { MDS_COLORS_INK_STRONG, MDS_COLORS_INK_WEAK } from '@rappi/mustache-b2b-foundations';
import { Button } from '@rappi/rests-commons-front';
import styled from 'styled-components';
export const TabsWrapper = styled.div `
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  border-radius: 8px;
  background-color: #fff;
  border-bottom: 1px solid #eceff3;
`;
export const TabWrapper = styled(Button) `
  display: flex;
  border-bottom: ${(props) => (props.isSelected ? '2px solid #F33959' : 0)};
  border-radius: 0;
  font-size: 16px;
  height: auto;
  padding: 24px 32px;
  color: #9aa9b9;

  & > div {
    color: ${(props) => (props.isSelected ? MDS_COLORS_INK_STRONG : MDS_COLORS_INK_WEAK)};
    gap: 8px;

    & > div {
      font-weight: 400;
    }
  }
`;
